import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Filter } from 'src/types/filter';

export interface FilterDrilldownState {
  isSelectedFilterDisplayed: boolean;
  selectedFilter?: Filter;
}

const initialState: FilterDrilldownState = {
  isSelectedFilterDisplayed: false,
};

export const { actions, reducer } = createSlice({
  name: 'filterDrilldown',
  initialState,
  reducers: {
    selectFilter: (state, action: PayloadAction<Filter>) => {
      state.isSelectedFilterDisplayed = true;
      state.selectedFilter = action.payload;
    },
    showList: (state) => {
      state.isSelectedFilterDisplayed = false;
    },
  },
});
